import { Parser } from '~/api';
import { RustServerImage } from '~/api/models';
import RequestService from './request';

interface GetRustServerImageRequest {
    type: string;
}

interface StoreRustServerImageRequest {
    type: string;
    file: File;
}

interface DeleteRustServerImageRequest {
    id: number;
}

class RustServerImagesService {
    get(data: GetRustServerImageRequest): Promise<RustServerImage> {
        return RequestService.get(`/servers/:server/rust/server-images/${data.type}`).then(Parser.parse);
    }

    store(data: StoreRustServerImageRequest): Promise<RustServerImage> {
        const formData = new FormData();
        formData.append('type', data.type);
        formData.append('file', data.file);

        return RequestService.post('/servers/:server/rust/server-images', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }).then(Parser.parse);
    }

    delete(data: DeleteRustServerImageRequest): Promise<void> {
        return RequestService.delete(`/servers/:server/rust/server-images/${data.id}`);
    }
}

export default new RustServerImagesService();
